"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrl = void 0;
const URL_PREFIX = "https://";
const sanitizeUrl = (url) => {
    if (url.startsWith("javascript:")) {
        url = url.slice(0, 4) + "\u0073" + url.slice(5, url.length);
    }
    return url;
};
const formatUrl = (absoluteURL) => {
    absoluteURL = sanitizeUrl(absoluteURL);
    if (absoluteURL.includes(URL_PREFIX) || absoluteURL.includes("http://")) {
        return absoluteURL;
    }
    return URL_PREFIX + absoluteURL;
};
exports.formatUrl = formatUrl;
//# sourceMappingURL=urls.js.map